/** Saves a session file to the manager's downloads. */
export const downloadSession = (fileName: string, text: string) => {
	const href = URL.createObjectURL(new Blob([text], { type: 'text/markdown' }));
	const anchor = document.createElement('a');
	anchor.href = href;
	anchor.download = fileName;
	anchor.click();
	// Some browsers start the download after click() returns, so the URL has to outlive this tick.
	setTimeout(() => URL.revokeObjectURL(href), 10000);
};
